<template>
    <div class="create_page" v-loading="loading">
        <div>
            <span style="font-size: 14px;font-weight: 600;padding-right: 20px;cursor: pointer;" @click="handleBack" v-matomo="{behaviorCategory: '自动化报告(模板管理)', event: '点击',  name: '创建模板-新(返回)'}">
                <i class="el-icon-back"></i>返回</span>|
            <span style="font-size: 14px;font-weight: 600;padding-right: 20px;padding-left: 20px;">
                <template v-if="type !== 'create'">
                    {{ pull.template_name }}
                </template>
                <template v-else>
                    创建模板
                </template>
            </span>
            <el-button  :disabled="disabledEdit" type="primary" size="mini" :loading="submitloading" @click="handleSaveSheetData" v-matomo="{behaviorCategory: '自动化报告(模板管理)', event: '点击',  name: isEdit?'编辑模板-新(保存)':'创建模板-新(保存)'}">保存</el-button>
        </div>
        <el-form :inline="true" :model="formInline" :rules="rules" ref="formInline" class="demo-form-inline" size="mini">
            <el-form-item label="模板名称" prop="template_name">
                <el-input :disabled="disabledEdit" v-model.trim="formInline.template_name" maxlength="20" show-word-limit placeholder="请输入模板名称"
                    style="width:230px;" clearable />
            </el-form-item>
            <el-form-item label="媒体" prop="plat_id">
                <ESelect 
                    class="other-select"
                    v-model="formInline.plat_id" 
                    :disabled="type === 'edit' || type === 'copy' || disabledEdit"
                    placeholder="请选择媒体" 
                    style="width:120px;"
                    @change="handlePlatIdChange"
                >
                    <!-- clearable -->
                    <el-option :label="item['name']" :value="item['id']" v-for="item in platList"
                        :key="item['name']"></el-option>
                </ESelect>
            </el-form-item>
            <el-form-item label="模板描述" prop="desc">
                <el-input :disabled="disabledEdit" v-model.trim="formInline.desc" maxlength="30" show-word-limit placeholder="请输入模板描述"
                    style="width:300px;" clearable />
            </el-form-item>
        </el-form>
        <div class="temp_create" :style="{ height: constentHeight + 'px' }">
            <div class="temp_option" :class="!showBar?'temp_option_bar':''">
                <div class="option_top" v-show="showBar">
                    <el-input 
                        placeholder="请输入查询关键字" 
                        prefix-icon="el-icon-search" 
                        :disabled="disabledEdit"
                        size="mini" 
                        clearable
                        v-model="keyword"
                    >
                    </el-input>
                    <el-tabs class="filter-tabs" v-model="activeOptionName" stretch>
                        <el-tab-pane label="数据维度" name="dimension" />
                        <el-tab-pane label="数据指标" name="field" />
                    </el-tabs>
                </div>
                <div class="option_list" v-show="showBar">
                    
                    <el-scrollbar :style="{height: constentHeight -100 +'px'}">
                        <el-collapse v-model="collapseDimensionList" v-if="activeOptionName === 'dimension'">
                            <el-collapse-item v-for="item in dimensionList" :key="item.id" :title="item.display_name"
                                :name="item.display_name">
                                <p v-for="child in item.children" :key="child.id" class="check_name">
                                    <el-checkbox :disabled="disabledEdit" :title="child.display_name" :name="child.display_name"
                                        :value="dimensionCheckIds.includes(child.name)"
                                        @change="(state) => handleCheckChange(state, 'dimensionCheckList', child)">
                                        {{ child.display_name }}
                                    </el-checkbox>
                                    <template v-if="showTitle(child)">
                                        <el-tooltip class="item" effect="dark" :content="showTitle(child)" placement="top">
                                            <i class="el-icon-question pointer"></i>
                                        </el-tooltip>
                                    </template>
                                    <i v-if="showFilterIcon(child) && !disabledEdit" class="el-icon-menu fr pr10 pointer pt6" :class="[isConditionActive(child)?'text-color-primary':'']" @click.stop="showConditionModal(child)" />
                                </p>
                            </el-collapse-item>
                        </el-collapse>
                        <el-collapse v-model="collapseFieldList" v-if="activeOptionName === 'field'">
                            <!-- collapseDimensionList -->
                            <el-collapse-item v-for="item in fieldsList" :key="item.id" :title="item.display_name"
                                :name="item.display_name">
                                <div class="check_all">
                                    <span @click="() => handleCheckChange(true, 'fieldsCheckList', item.children)">全选</span>
                                    <span
                                        @click="() => handleCheckChange(false, 'fieldsCheckList', item.children)">取消全选</span>
                                </div>
                                <p v-for="child in item.children" :key="child.id" class="check_name">
                                    <el-checkbox :disabled="disabledEdit" :title="child.display_name" :name="child.display_name"
                                        :value="fieldsCheckIds.includes(child.name)"
                                        @change="(state) => handleCheckChange(state, 'fieldsCheckList', child)">
                                        {{ child.display_name }}
                                    </el-checkbox>
                                    <template v-if="showTitle(child)">
                                        <el-tooltip class="item" effect="dark" :content="showTitle(child)" placement="top">
                                            <i class="el-icon-question pointer"></i>
                                        </el-tooltip>
                                    </template>
                                </p>
                            </el-collapse-item>
                        </el-collapse>

                    </el-scrollbar>
                </div>
                <div v-if="keyword" class="option_list_filter">
                    <el-scrollbar style="height: 100%">
                        <p v-if="!filterList.hasData" class="no_data">暂无数据</p>
                        <div class="filter_item" v-for="item in filterList.list" :key="item.name">
                            <div v-show="item.list.length" class="title">{{item.name}}</div>
                            <p v-for="child in item.list" :key="child.id" class="check_name">
                                <el-checkbox :title="child.display_name" :name="child.display_name"
                                    :value="[...dimensionCheckIds, ...fieldsCheckIds ].includes(child.name)"
                                    @change="(state) => handleCheckChange(state, item.key, child)">
                                    {{ child.display_name }}
                                </el-checkbox>
                                <template v-if="showTitle(child)">
                                    <el-tooltip class="item" effect="dark" :content="showTitle(child)" placement="top">
                                        <i class="el-icon-question pointer"></i>
                                    </el-tooltip>
                                </template>
                                <i v-if="item.showIcon&&showFilterIcon(child) && !disabledEdit"  class="el-icon-menu fr pr10 pointer pt6" :class="[isConditionActive(child)?'text-color-primary':'']" @click.stop="showConditionModal(child)" />
                            </p>
                        </div>
                    </el-scrollbar>
                </div>
                <div class="option_btn" @click="handleShowBarChange">
                    <i :class="showBar?'el-icon-caret-left':'el-icon-caret-right'"></i>
                </div>
            </div>
            <div class="temp_select">
                <div class="temp_select_list">

                    <div class="temp_select_item">
                        <div class="item_name">
                            筛选
                        </div>
                        <Draggable :disabled="disabledEdit" class="item_list" v-model="showConditionList" draggable=".select_item" :group="{ name: 'condition'}" @end="() => onEnd('conditionCheckList', hideConditionList, showConditionList)">
                            <div v-for="item in showConditionList" :key="item.display_name" class="select_item ellipsis" 
                                :class="{
                                    'is-exclude': item.isExclude,
                                    'grey_color': !initDimensionNames[item.name],
                                    change_color: item.display_name !== initDimensionNames[item.name]&&initDimensionNames[item.name]
                                }" 
                                @click="handleEditCondition(item)"
                            >
                                <p class="ellipsis" :title="getTitle(item, initDimensionNames, 'dimension')">
                                    {{ item.display_name }}
                                    <template v-if="item.sub_text">：<div class="info">{{item.sub_text}}</div></template>
                                </p>
                                <span v-if="!disabledEdit" @click.stop="handleCheckChange(false, 'conditionCheckList', item)">X</span>
                            </div>
                            <template v-if="conditionCheckList.length > showMaxOption">
                                <el-popover placement="bottom-end" width="200" trigger="click">
                                    <Draggable :disabled="disabledEdit" class="popover-drag" v-model="hideConditionList" draggable=".select_item"
                                               :group="{ name: 'condition' }"
                                               @end="() => onEnd('conditionCheckList', hideConditionList, showConditionList)">
                                        <template v-for="(item) in hideConditionList">
                                            <!--  -->
                                            <div :key="item.display_name" class="select_item ellipsis" 
                                                :class="{
                                                    'is-exclude': item.isExclude,
                                                    'grey_color': !initDimensionNames[item.name],
                                                    change_color: item.display_name !== initDimensionNames[item.name]&&initDimensionNames[item.name]
                                                }"
                                                 @click="handleEditCondition(item)">
                                                <p class="ellipsis" :title="getTitle(item, initDimensionNames, 'dimension')">
                                                    {{ item.display_name }}
                                                    <template v-if="item.sub_text">：<div class="info">{{item.sub_text}}</div></template>
                                                </p>
                                                <span
                                                     v-if="!disabledEdit"
                                                    @click.stop="handleCheckChange(false, 'conditionCheckList', item)">X</span>
                                            </div>
                                        </template>
                                    </Draggable>
                                    <el-button size="mini" type="primary" plain slot="reference">+{{ conditionCheckList.length - showMaxOption }}</el-button>
                                </el-popover>
                            </template>
                        </Draggable>
                        <div v-if="!disabledEdit" class="temp_select_del" @click="handleDelAll('conditionCheckList')">清除</div>
                    </div>

                    <div class="temp_select_item">
                        <div class="item_name">
                            维度
                        </div>
                        <Draggable :disabled="disabledEdit" class="item_list" v-model="showDimensionList" draggable=".select_item"
                            :group="{ name: 'dimension' }"
                            @end="() => onEnd('dimensionCheckList', hideDimensionList, showDimensionList)">
                            <div v-for="item in showDimensionList" :key="item.display_name" class="select_item ellipsis"
                                @click="handleEditDimension(item)">
                                <p class="ellipsis" :title="getTitle(item, initDimensionNames, 'dimension')" :class="{change_color: item.display_name !== initDimensionNames[item.name]&&initDimensionNames[item.name],grey_color: !initDimensionNames[item.name] }">
                                    {{ item.display_name }}
                                    <template v-if="item.sub_text">：<div class="info">{{item.sub_text}}</div></template>
                                </p>
                                <span  v-if="!disabledEdit" @click.stop="handleCheckChange(false, 'dimensionCheckList', item)">X</span>
                            </div>
                            <template v-if="dimensionCheckList.length > showMaxOption">
                                <el-popover placement="bottom-end" width="200" trigger="click">
                                    <Draggable :disabled="disabledEdit" class="popover-drag" v-model="hideDimensionList" draggable=".select_item"
                                        :group="{ name: 'dimension' }"
                                        @end="() => onEnd('dimensionCheckList', hideDimensionList, showDimensionList)">
                                        <template v-for="(item) in hideDimensionList">
                                            <div :key="item.display_name" class="select_item ellipsis"
                                                @click="handleEditDimension(item)">
                                                <p class="ellipsis" :title="getTitle(item, initDimensionNames, 'dimension')" :class="{change_color: item.display_name !== initDimensionNames[item.name]&&initDimensionNames[item.name],grey_color: !initDimensionNames[item.name]}" >
                                                    {{ item.display_name }}
                                                    <template v-if="item.sub_text">：<div class="info">{{item.sub_text}}</div></template>
                                                </p>
                                                <span
                                                    v-if="!disabledEdit"
                                                    @click.stop="handleCheckChange(false, 'dimensionCheckList', item)">X</span>
                                            </div>
                                        </template>
                                    </Draggable>

                                    <el-button size="mini" type="primary" plain
                                        slot="reference">+{{ dimensionCheckList.length - showMaxOption }}</el-button>
                                </el-popover>
                            </template>
                        </Draggable>
                        <div v-if="!disabledEdit" class="temp_select_del" @click="handleDelAll('dimensionCheckList')">清除</div>
                    </div>

                    <div class="temp_select_item">
                        <div class="item_name">
                            指标
                        </div>
                        <Draggable :disabled="disabledEdit" class="item_list" v-model="showFieldsList" draggable=".select_item"
                            :group="{ name: 'field' }" @end="() => onEnd('fieldsCheckList', hideFieldsList, showFieldsList)">
                            <template v-for="(item) in showFieldsList">
                                <div 
                                    :key="item.display_name" 
                                    class="select_item ellipsis" 
                                    @click="handleEditFields(item)"  
                                    :title="getTitle(item, initFieldsNames, 'field')" 
                                    :class="{change_color: item.display_name !== initFieldsNames[item.name]&&initFieldsNames[item.name],grey_color: !initFieldsNames[item.name]}"
                                >
                                    <p class="ellipsis">{{ item.display_name }}</p>
                                    <span  v-if="!disabledEdit" @click.stop="handleCheckChange(false, 'fieldsCheckList', item)">X</span>
                                </div>
                            </template>
                            <template v-if="fieldsCheckList.length > showMaxOption">
                                <el-popover placement="bottom-end" width="200" trigger="click">
                                    <Draggable :disabled="disabledEdit" class="popover-drag" v-model="hideFieldsList" draggable=".select_item" :group="{ name: 'field' }"
                                        @end="() => onEnd('fieldsCheckList', hideFieldsList, showFieldsList)">
                                        <template v-for="(item) in hideFieldsList">
                                            <div 
                                                :key="item.display_name" 
                                                class="select_item item_3 ellipsis"
                                                @click="handleEditFields(item)"
                                                :title="getTitle(item, initFieldsNames, 'field')"
                                                :class="{
                                                    change_color: item.display_name !== initFieldsNames[item.name]&&initFieldsNames[item.name],
                                                    grey_color: !initFieldsNames[item.name]
                                                }"
                                            >
                                               <p class="ellipsis"> {{ item.display_name }}</p>
                                                <span  v-if="!disabledEdit" @click.stop="handleCheckChange(false, 'fieldsCheckList', item)">X</span>
                                            </div>
                                        </template>
                                    </Draggable>

                                    <el-button size="mini" type="primary" plain slot="reference">+{{ fieldsCheckList.length -
                                        showMaxOption }}</el-button>
                                </el-popover>
                            </template>
                        </Draggable>

                        <div v-if="!disabledEdit" class="temp_select_del" @click="handleDelAll('fieldsCheckList')">清除</div>
                    </div>
                    <div class="temp_select_handle">
                        <el-button size="mini" type="primary" @click="showTableHeader">预览表头</el-button>
                        <el-button size="mini" :disabled="disabledEdit" @click="handleDelAllSelect">清空已选条件</el-button>
                    </div>
                </div>
                <div class="temp_select_table">
                    <template v-for="item in headList">
                        <div 
                            class="table_header sheet_item"  
                            v-for="child in item.list" 
                            :key="child.id" 
                            :class="{change_color: child.display_name !== item.init[child.name]&&item.init[child.name], grey_color: !item.init[child.name], [item.class]: true}"
                            :title="child.display_name !== item.init[child.name]&&item.init[child.name]?'原名称：'+item.init[child.name]:''"
                        >
                            {{ child.display_name }}
                        </div>
                    </template>
                </div>
                <div class="temp_select_tip">
                    <div class="tip ">
                        温馨提示:
                    </div>
                    <div class="tip_item"><img src="~@/assets/img/tip.png" /> 已经添加的sheet、筛选、维度、指标可拖动修改位置。</div>
                    <div class="tip_item"><img src="~@/assets/img/tip.png" /> 点击预览表头，可查看实际表头列的位置。</div>
                    <div class="tip_item"><img src="~@/assets/img/tip.png" /> 维度或指标修改名称后，会显示绿色字体，鼠标悬停至名称上时，可查看原名称。</div>
                    <div class="tip  pt20">
                        正文数据显示:
                    </div>
                    <div class="tip_item"><img src="~@/assets/img/tip.png" /> 您可指定一个sheet，将获取指定sheet的指标与指标顺序，在邮件正文内显示最多近7天的每日汇总数据。</div>
                </div>
                <div class="select_sheet">
                    <div><el-button type="primary" size="mini" @click="handleSelectSheet">指定sheet</el-button></div>
                    <div class="tip">已指定：</div>
                    <div v-if="!selectSheetItem" class="tip" style="color:red">当前未指定sheet</div>
                    <div  v-else class="select_sheet_list" >
                        <div 
                            class="select_sheet_item ellipsis"
                        >
                            <p class="ellipsis"> {{ selectSheetItem.name }}</p>
                            <span  v-if="!disabledEdit" @click.stop="selectSheetItem = null">X</span>
                        </div>
                    </div>
                </div>
                <div class="temp_select_tip">
                    <div class="tip">Excel指标数据格式设置：</div>
                    <div style="margin: 10px 0;">
                        <el-radio-group v-model="excel_format_type" :disabled="disabledEdit">
                            <el-radio :label="'0'">
                                使用默认格式
                                <el-tooltip class="item" effect="dark" content="当前线上的excel数据格式，不发生任何变化，历史文件发送后不发生任何变化。" placement="top">
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                            </el-radio>
                            <el-radio :label="'1'">
                                按照指标类型字段匹配格式
                                <el-tooltip class="item" effect="dark" content="按照每个数据指标的类型定义单元格数据格式（日期变为日期格式，数据指标显示结果不发生变化，格式发生变化）" placement="top">
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                            </el-radio>
                        </el-radio-group>
                    </div>
                </div>
            </div>
        </div>
        <div class="sheet_box">
            <div class="sheet_list" :class="{ 'sheet_width': sidebar.opened }">
                <div v-if="showRunButton" class="sheet_run sheet_left" @click="handleScrollSheet(-1)">
                    <i class="el-icon-arrow-left"></i>
                </div>
                <div class="draggable_box" :class="{ 'lock': showRunButton }">
                    <Draggable ghost-class="drag-ghost" :disabled="disabledEdit" v-model="sheetList" class="draggable_target" draggable=".sheet_item">
                        <div v-for="(sheet, index) in sheetList" :key="index" :name="sheet.name" class="sheet_item"
                            :class="{ active: sheet.name === activeSheet }" @click="handleSheetClick(sheet)">
                            <div class="info">
                                <i class="el-icon-rank"></i>
                                <span class="sheet_name ellipsis" :title="sheet.name">{{ sheet.name }}</span>
                                <i class="el-icon-document-copy" v-if="!disabledEdit" @click.stop="handleCopySheet(sheet)"></i>
                                <i class="el-icon-edit-outline" v-if="!disabledEdit" @click.stop="handleEditSheet(sheet)"></i>
                                <el-popconfirm title="确认要删除吗，删除后不可恢复！" confirm-button-type="danger" icon-color='red'
                                    icon='el-icon-info' @confirm="() => handleDelSheet(sheet)">
                                    <i slot="reference"  v-if="!disabledEdit" class="el-icon-delete" @click.stop></i>
                                </el-popconfirm>
                            </div>
                        </div>
                    </Draggable>
                </div>

                <div v-if="showRunButton" class="sheet_run sheet_right" @click="handleScrollSheet(1)">
                    <i class="el-icon-arrow-right"></i>
                </div>
                <div>
                    <div v-if="!disabledEdit" class="sheet_add" @click="handleAddSheet">+添加</div>
                </div>
            </div>
        </div>

        <!-- 筛选 弹框 -->
        <ContentModal
            ref="contentModal"
            :plat-id="formInline['plat_id']"
            :modal-data="actionConditionModal"
            :auto-load-fields="autoLoadFields"
            :condition="conditionCheckList"
            @save-value="saveConditionValue"
            @close="closeConditionModal"
        />
        
        <DimensionModal 
            ref="dimensionModal" 
            :plat-id="formInline['plat_id']" 
            :modal-data="actionDimensionModal"
            :all-dimensions="dimensionList"
            :all-field="dimensionModalFieldsList" 
            :select-target="appleFieldsCheckList"
            :dimensions="dimensionCheckList" 
            :shown-field="showDimensionList"
            :hidden-field="hideDimensionList" 
            :condition="conditionCheckList"
            @save-value="saveDimensionValue" />

        <!-- 指标弹框 -->
        <TargetModal
            ref="targetModal" 
            :plat-id="formInline['plat_id']" 
            :modal-data="actionFieldsModal"
            :all-dimensions="dimensionList"
            :all-field="fieldsTypeList" 
            :select-dimensions="dimensionCheckList"
            :targets="fieldsCheckList" 
            :shown-field="showFieldsList"
            :hidden-field="hideFieldsList"
            @save-value="saveFieldsValue"
        />
    </div>
</template>
<script>
import Draggable from 'vuedraggable';
import { cloneDeep, uniqBy, uniq, throttle, flatten } from 'lodash'
import HomeAPI from '@/api/home.js';
import TemAPI from '@/api/efficiencyTool/template_new.js';
import { mapGetters } from 'vuex'
import { addSheetDialog, selectModal, selectSheetDialog } from './modal'
import ContentModal from '../../modal/contentModal';
// import DateModal from '../../modal/dateModal';
// import TimeModal from '../../modal/timeModal';
// import DateSelectModal from '../../modal/dateSelectModal';
// import SelectModal from '../../modal/selectModal';

import DimensionModal from '../../modal/dimensionModal'
import TargetModal from '../../modal/targetModal'
import { validEmoji, validHtml } from "@/utils/validate.js"
/**
 * 苹果需要验证的字段
 */
const APPLE_DIMENSION_TYPE = {
    search_term_text: '搜索词',
    date: '数据日期（天）'
};
const APPLE_FIELDS_TYPE ={
    impression_share: '展示次数份额',
    impression_rank: '排名',
    search_popularity: '搜索热度'
}
//默认的维度&指标&sheet参数
const defaultDimensionNames = ['date'],
defaultConditionNames = ['time_zone'],
defaultFieldNames=['cost', 'local_spend', 'ad_billing'],   // ad_billing 荣耀 总消耗    local_spend 总消耗支出
defaultDimensionData = {
    sum_type: '',
    start_date_dimension: '',
    create_date_dimension: '',
    yy_type_dimension: '',
    order_by: '',
    order_type: 'desc',
    show_type: '1',
    show_num: null,
    subText: '',
};
const getDefaultSheetData = ()=> {
    const defaultSheetName = "Sheet1",
        defaultSheetParams = {
            conditionConfig: [],
            dimensionConfig: [],
            fieldConfig: [],
            otherConfig: [],
            // excel_format_type: '1',
        }
    return {
        defaultSheetName,
        defaultSheetParams
    }
}
export default {
    name: 'efficiencyTool_temp_create',
    components: {
        Draggable,
        ContentModal,
        // DateModal,
        // TimeModal,
        // DateSelectModal,
        // SelectModal,
        DimensionModal,
        TargetModal
    },
    props: ['allowedPlatList', 'pull', 'type'],
    data() {
        const blackList = ['爱奇艺']
        // 默认小米id
        let defaultPlatId = '',{ defaultSheetName, defaultSheetParams } = getDefaultSheetData();
        if (this.type === 'create') {
            const pList = this.allowedPlatList.filter(v=>!blackList.includes(v.name));
            if (pList.length) {
                defaultPlatId = pList[0].id;
            }
        }
        else {
            defaultPlatId = this.pull.plat_id
        }
        function validateName(rule, value, callback) {
            if (validHtml(value)) {
                callback(new Error('不能输入html标签'))
            }else {
                if (validEmoji(value)) {
                    callback(new Error('不能输入表情'))
                }else {
                    callback()
                }
            }
        }
        const defaultSheet = {
            name: defaultSheetName,
            list: {
                ...cloneDeep(this.defaultSheetParams)
            },
        }
        return {
            selectSheetItem: null,
            defaultSheetParams,
            initFieldsNames: {}, //记录原始值
            initDimensionNames: {},//记录原始值
            keyword: '',
            showBar: true,
            prePlatId: defaultPlatId,
            actionDimensionModal: {},
            actionConditionModal:{},
            actionFieldsModal:{},
            blackList,//数据黑名单
            loading: false,
            submitloading: false,
            formInline: {
                template_name: '',
                desc: '',
                plat_id: defaultPlatId,
                condition: []
            },
            rules: {
                template_name: [
                    { required: true, message: '请输入模板名称', trigger: 'blur' },
                    { min: 1, max: 20, message: '长度不超过20个字符', trigger: 'blur' },
                    { validator: validateName, trigger: 'blur' }
                ],
                plat_id: [
                    { required: true, message: '请选择媒体', trigger: 'change' }
                ],
                desc: [
                    { validator: validateName, trigger: 'blur' }
                ]
            },
            activeOptionName: 'dimension',
            dimensionTypeList: [],
            fieldsTypeList: [],
            // 筛选
            conditionCheckList:[],
            showConditionList: [],
            hideConditionList: [],
            // 维度
            dimensionCheckList: [],
            showDimensionList: [],
            hideDimensionList: [],
            // 指标
            fieldsCheckList: [],
            showFieldsList: [],
            hideFieldsList: [],
            excel_format_type: '1',  // excel格式类型
            collapseFieldList: [],
            collapseDimensionList: [],
            constentHeight: 300,//内容高度
            showMaxOption: 0,//最多显示多少个数据
            sheetList: [
                defaultSheet
            ],
            showRunButton: false,
            activeSheet: defaultSheetName,
            // 内容弹窗列表内容需要自动加载的字段,也用来区分前端筛选后端筛选
            autoLoadFields:[
                'bloc_name',
                'company_name',
                'account_id',
                'account_name',
                'app_id',
                'app_name',
                'main_app_name',
                'project_name',
                'package_name',
                'plan_id',
                'plan_name',
                'adgroup_id',
                'adgroup_name',
                'ad_id',
                'ad_name',
                'idea_id',
                'idea_name',
                'task_id',
                'task_name',
                'sub_task_id',
                'sub_task_name',
                'campaign_id',
                'campaign_name',
                'keyword_id',
                'key_word_text',
                'search_term_text',
                'subproject_content',
                'subproject_name',
                'subproject_id',
            ],
            headList: []
        }
    },
    computed: {
        ...mapGetters(['sidebar']),
        isEdit(){
            return this.type == 'edit';
        },
        platList() {
            return this.allowedPlatList.filter(item=>{
                return !this.blackList.includes(item.name);
            })
        },
        dimensionCheckIds() {
            return this.dimensionCheckList.map(v=>v.name)
        },
        fieldsCheckIds() {
            return this.fieldsCheckList.map(v=>v.name)
        },
        dimensionList() {
            if (!this.formInline.plat_id) {
                return []
            };
            return this.dimensionTypeList.filter((v) => {
                return !this.blackList.includes(v.display_name);
            }).find(v => {
                return v.name === 'data_' + this.formInline.plat_id
            })?.children || [];
        },
        fieldsList() {
            if (!this.formInline.plat_id) {
                return []
            };
            return this.fieldsTypeList.filter((v) => {
                return !this.blackList.includes(v.display_name);
            }).find(v => {
                return v.name === 'data_' + this.formInline.plat_id
            })?.children || [];
        },

        isTimeFilter(){
            let conditions = this.conditionCheckList.map(item=>item.name);
            let dimensions = this.dimensionCheckList.map(item=>item.name);
            return conditions.includes('time_interval')||dimensions.includes('time_interval');
        },
        filterList() {
            const dimensions = this.dimensionList.reduce((pre, item)=> {
                    if (item.children.length) {
                        pre.push(...item.children)
                    }
                    return pre
                }, []).filter(v=> {
                    return (v.display_name || "").toLocaleLowerCase().indexOf(this.keyword.toLocaleLowerCase()) > -1
                })
            const fields = this.fieldsList.reduce((pre, item)=> {
                if (item.children.length) {
                    pre.push(...item.children)
                }
                return pre
            }, []).filter(v=> {
                return (v.display_name || "").toLocaleLowerCase().indexOf(this.keyword.toLocaleLowerCase()) > -1
            });
            return {
                hasData: dimensions.length || fields.length,
                list: [
                    {
                        name: '数据维度',
                        list: dimensions,
                        key: 'dimensionCheckList',
                        showIcon: true 
                    },
                    {
                        name: '数据指标',
                        list: fields,
                        key: 'fieldsCheckList'
                    },
                ]
            }
        },
        disabledEdit() {
            return this.type === 'info'
        },
        dimensionModalFieldsList() {
            const fieldsValidNames = Object.keys(APPLE_FIELDS_TYPE);
            if (this.formInline.plat_id === '9') {
                return this.fieldsList.map(v=> {
                    return {
                        ...v,
                        children: v.children.filter(v=> !fieldsValidNames.includes(v.name))
                    }
                })
            }
            return this.fieldsList;
        },
        appleFieldsCheckList() {
            const fieldsValidNames = Object.keys(APPLE_FIELDS_TYPE);
            if (this.formInline.plat_id === '9') {
                return this.fieldsCheckList.filter(v=> !fieldsValidNames.includes(v.name))
            }
            return this.fieldsCheckList;
        }
    },
    watch: {
        fieldsList(n, o) {
            this.collapseFieldList = n.map(v => v.display_name);
        },
        dimensionList(n, o) {
            this.collapseDimensionList = n.map(v => v.display_name);
        },
        sheetList(n) {
            this.sheetItemNum()
        },
        sidebar() {
            this.sheetItemNum()
        },
        activeSheet(n) {
            const sheet = this.sheetList.find(v=> {
                return n === v.name
            });
            this.headList = sheet.headList || []
        }
    },
    async created() {
        document.body.ondrop = function(event) {
            event.preventDefault()
            event.stopPropagation()
        }
        
        // await this.getPageAllowAction();
        this.getPageAllowAction();
        if (this.type === 'create') {
            this.selectSheetItem = this.sheetList[0]
        }
        if (['info', 'edit', 'copy'].includes(this.type)) {
            this.getTemInfoData()
        }
    },
    mounted() {
        this.resetDocHeight();
        const fn = throttle(()=>{
            this.resetDocHeight()
            this.resetOptionWidth()
        }, 300)
        window.addEventListener('resize', fn)
        this.$once('hook:beforeDestroy', () => {
            window.removeEventListener('resize', fn)
        });
        this.$nextTick(() => {
            this.resetOptionWidth()
        })
    },
    methods: {
        resetTemData() {
            const { defaultSheetName, defaultSheetParams } = getDefaultSheetData();
            this.defaultSheetParams = defaultSheetParams;
            
            this.initParamsData()
            const defaultSheet = {
                name: defaultSheetName,
                list: {
                    ...cloneDeep(this.defaultSheetParams)
                },
            }
            this.sheetList = [
                defaultSheet
            ];
            this.selectSheetItem =  this.sheetList[0];
            this.activeSheet = ''
            this.handleSheetClick(this.sheetList[0])
        },
        // 指定sheet
        handleSelectSheet() {
            this.updateSheetData();
            const onSubmit = (data) => {
                console.log(data);
                this.selectSheetItem = data;
                vm.close();
            }
            const { vm } = selectSheetDialog({
                props: {
                    list: this.sheetList,
                    check: this.selectSheetItem?.name || "",
                    disabled: this.type === 'info'
                },
                cbs: {
                    onSubmit
                }
            })
        },
        // 保存sheet数据
        handleSaveSheetData() {
             this.$refs['formInline'].validate((valid) => {
                if (valid) {
                    this.updateSheetData();
                    const { template_name, plat_id, desc } = this.formInline;
                    let hasDimension = {
                        hasData: true,
                        names: []
                    },hasField = {
                        hasData: true,
                        names: []
                    };
                    // email_check email_sort
                    const checkName = this.selectSheetItem?.name || '';
                    const list = this.sheetList.map(v=> {
                        const { id, list: { conditionConfig, dimensionConfig, fieldConfig, otherConfig }, name } = v;
                        if (!dimensionConfig.length) {
                            hasDimension.hasData = false;
                            hasDimension.names.push(name)

                        };
                        if (!fieldConfig.length) {
                            hasField.hasData = false;
                            hasField.names.push(name)
                        }
                        const item = {
                            sheet_name: name,
                            email_check: +(checkName ===name),
                            list: {
                                condition_config: conditionConfig.map(item=> {
                                    return {
                                        name:item.name,
                                        display_name:item.display_name,
                                        value:{
                                            contentValue:item.contentValue,
                                            dateValue:item.dateValue,
                                            selectValue:item.selectValue,
                                            selectLabel:item.selectLabel,
                                            timeValue:item.timeValue,
                                        },
                                        isExclude:item.isExclude,
                                    }
                                }),
                                dimension_config: dimensionConfig.map(item=> {
                                        return {
                                            name:item.name,
                                            display_name:item.display_name,
                                            sub_text:item.sub_text,
                                            order_by:item.order_by,
                                            order_type:item.order_type,
                                            show_num:item.show_num,
                                            show_type:item.show_type,
                                            start_date_dimension:item.start_date_dimension,
                                            create_date_dimension:item.create_date_dimension,
                                            yy_type_dimension:item.yy_type_dimension,
                                            sum_type:item.sum_type,
                                        }
                                }),
                                field_config: fieldConfig.map(item=> {
                                    return {
                                        name:item.name,
                                        display_name:item.display_name,
                                    }
                                }),
                                other_config: otherConfig,
                            }
                        };
                        if (id && this.type === 'edit') {
                            item.sheet_id = id
                        }
                        return item;
                    });
                    if (!hasDimension.hasData) {
                        this.$message.warning(hasDimension.names.join('、')+'，最少需选择一个维度')
                        return;
                    }
                    if (!hasField.hasData) {
                        this.$message.warning(hasField.names.join('、')+'，最少需选择一个指标')
                        return;
                    }
                    const params = {
                        template_name,
                        plat_id,
                        desc,
                        sheets: JSON.stringify(list),
                        excel_format_type: this.excel_format_type
                    };
                    this.submitloading = true;
                    if (this.type === 'edit') {
                        params.template_id = this.pull.template_id;
                        TemAPI.postTempleateEdit(params)
                        .then(res=> {
                            this.$message.success('编辑成功');
                            this.handleBack()
                        })
                        .catch((err)=> {
                           tipErr(err)
                        })
                        .finally(()=> {
                            this.submitloading = false;
                        });
                    }else {
                        // 复制为2   新增为1
                        if (this.type === 'copy') {
                            params.type = 2;
                        }else {
                             params.type = 1;
                        }
                        
                        TemAPI.postTempleateAdd(params)
                        .then(res=> {
                            this.$message.success('添加成功');
                            this.handleBack()
                        })
                        .catch((err)=> {
                           tipErr(err)
                        })
                        .finally(()=> {
                            this.submitloading = false;
                        });
                       
                    };
                    const tipErr = (err)=>{
                        let meg =  err.info
                        if (err?.data.error) {
                            const arr = Object.values(err?.data.error)
                            if (arr) {
                              meg += (": " + [...new Set(flatten(arr))].join('、'))
                            }
                            // dimension_config condition_config field_config
                        }
                         this.$message.error( meg || '操作失败，请重试')
                    }
                } else {
                    return false;
                }
            });
            

        },
        // 是否显示筛选图标
        showFilterIcon(item) {
           try {
             const config = JSON.parse(item.config);
             return config.condition
           } catch (error) {
             return false
           }
        },
        isConditionActive(item){
            return !!this.conditionCheckList.find(inner=>inner.name==item.name);
        },
        async getTemInfoData() {
            const { plat_id, template_id , template_name, desc } = this.pull || {}
            const params = { plat_id, template_id, type: 1 }
            TemAPI.getTempleateInfo(params).then(res=> {
                const { sheets } = res.data;
                this.sheetList = sheets.map(v=> {
                    const { condition_config, dimension_config, field_config, other_config, excel_format_type } = v.list;
                    // const uniqBy_condition_config = uniqBy(condition_config, this.show)
                    const item = {
                        name: v.sheet_name,
                        id: v.sheet_id,
                        email_check: v.email_check,
                        email_sort: v.email_sort,
                        list:{
                            conditionConfig: condition_config.map(item=>{
                                item.contentValue = item.value.contentValue;
                                item.sub_text = this.getConditionSubText(item,item.contentValue,'content');
                                return item;
                            }),
                            dimensionConfig: dimension_config,
                            fieldConfig: field_config,
                            otherConfig: other_config,
                            // excel_format_type: excel_format_type
                        },
                    }
                    if (+v.email_check) {
                        this.selectSheetItem = item;
                    };
                    return item
                });
                this.excel_format_type = res.data.excel_format_type;
                this.formInline = Object.assign({}, this.formInline, {
                    plat_id, template_name, desc
                });
                // 如果是复制模板   主动触发名称验证
                if( this.type === 'copy') {
                    this.$nextTick(()=> {
                        this.$refs.formInline.validateField('template_name')
                    })
                }
                this.activeSheet = "";
                this.handleSheetClick(this.sheetList[0])
            }).catch(err=> {
                console.log(err,'新模板创建、编辑');
                this.$message.warning(err.info || '未知错误,请重试');
                this.handleBack()
            });
            
        },
        getTitle(item, init, type) {
            if (!init[item.name]) {
                return item.display_name
            }
            const str = item.display_name === init[item.name]?item.display_name:'(原名称:'+init[item.name]+') '+item.display_name
            if ('field' === type) {
                return str
            }else if ('dimension' === type) {
                return str + (item.sub_text?':' +item.sub_text :'')
            };
            return '';
        },
        // 指标保存
        saveFieldsValue(params) {
            const item = this.fieldsCheckList.find(v=> {
                return v.name === params.name
            });
            this.$set(item, 'display_name', params.display_name)
        },
        // 编辑指标
        handleEditFields(data) {
            if (!this.initFieldsNames[data.name]) {
                this.$message.warning('该字段无权限');
                return
            }
            const params = { ...data, initName: this.initFieldsNames[data.name], type: this.type };
            this.actionFieldsModal = params;
            this.$nextTick(()=> {
                this.$refs.targetModal.showModal();
            })
        },
        handleShowBarChange() {
            this.showBar = !this.showBar;
            this.$nextTick(()=> {
                this.resetOptionWidth()
                this.fieldsCheckListFn() 
                this.dimensionCheckListFn()
            })
        },
        // 筛选 设置参数
        async saveConditionValue(field, val, valueType, addDimension = true) {
            let sub_text = this.getConditionSubText(field, val, valueType);
            let fieldItem = this.conditionCheckList.find(item => item.name == field.name);
            let formGroupItem = this.dimensionCheckList.find(item =>item.name == field.name);
            let conditionItem = this._findFieldByName(this.dimensionList, field.name);
            // 如果不选择筛选项  就不添加筛选数据
            if (!val.length) {
                fieldItem&&await this.handleCheckChange(false, 'conditionCheckList', fieldItem);
                return;
            }
            if (!fieldItem) {
                if(!formGroupItem){
                    if (addDimension) {
                        /* 勾选筛选条件的字段时，自动勾选该字段维度 */
                        let dimensionField =  this._findFieldByName(this.dimensionList, field.name);
                        let dimensionIndex = this.dimensionCheckList.findIndex(item=>item.name==dimensionField.name);
                        if(field.name=='start_date'||field.name=='create_date'){
                            if((val.date||[]).length>0&&dimensionIndex==-1){
                                await this.handleCheckChange(true,'dimensionCheckList',dimensionField);
                            }
                        }else{
                            if(val.length>0&&dimensionIndex==-1){
                                await this.handleCheckChange(true,'dimensionCheckList',dimensionField);
                            }
                        }
                    }
                    


                    /*如果是初次选中开投日期、则维度的开投日期维度保持一致*/
                    if(valueType=='date_select'){
                        if(field.name=='start_date'){
                            let startDateDimension = this.dimensionCheckList.find(item=>item.name=='start_date');
                            if(startDateDimension){
                                this.$set(startDateDimension,'start_date_dimension',val.select);
                                this.$set(startDateDimension, 'subText', val.selectLabel);
                            }
                        }else if(field.name=='create_date'){
                            let createDateDimension = this.dimensionCheckList.find(item=>item.name=='create_date');
                            if(createDateDimension){
                                this.$set(createDateDimension,'create_date_dimension',val.select);
                                this.$set(createDateDimension, 'subText', val.selectLabel);
                            }
                        }

                    }
                    /*如果是初次选中运营类型、则维度的运营类型维度保持一致*/
                    if(field.name=='yy_type'){
                        let yyTypeDimension = this.dimensionCheckList.find(item=>item.name=='yy_type');
                        if(yyTypeDimension){
                            this.$set(yyTypeDimension,'yy_type_dimension',field.select);
                            this.$set(yyTypeDimension, 'subText', field.selectLabel);
                        }
                    }
                }
                await this.handleCheckChange(true, 'conditionCheckList', cloneDeep(conditionItem))
                fieldItem = this.conditionCheckList.find(item => item.name == field.name);
            }
            if (valueType == 'content') {
                this.$set(fieldItem, 'contentValue', val.length > 0 ? val : []);
                this.$set(fieldItem,'isExclude',val.length > 0 ? field.isExclude : false);
                if(field.name=='yy_type'){
                    this.$set(fieldItem, 'selectValue', field.select);
                    this.$set(fieldItem, 'selectLabel', field.selectLabel);
                }
            } else if (valueType == 'time') {
                this.$set(fieldItem, 'timeValue', val);
            } else if (valueType == 'date') {
                this.$set(fieldItem, 'dateValue', val);
            } else if (valueType == 'select') {
                this.$set(fieldItem, 'selectValue', val.select);
                this.$set(fieldItem, 'selectLabel', val.selectLabel);
            } else {
                this.$set(fieldItem, 'timeValue', val.time);
                this.$set(fieldItem, 'dateValue', val.date);
                this.$set(fieldItem, 'selectValue', val.select);
                this.$set(fieldItem, 'selectLabel', val.selectLabel);
            }
            this.$set(fieldItem,'sub_text',sub_text);

            if (val <= 0) {
                this.removeCondition(fieldItem);
            } else {
                this.$set(fieldItem, 'checked', true);
            }
            return fieldItem;
        },
        removeCondition(field){
            let index = this.conditionCheckList.findIndex(item => item.name == field.name);
            if(index!=-1){
                this.conditionCheckList.splice(index, 1);
            }
            let actionItem = this._findFieldByName(this.conditionList, field.name);
            if (actionItem) {
                this.$set(actionItem, 'checked', false);
                this.$set(actionItem, 'contentValue', []);
                this.$set(actionItem, 'selectValue', '');
                this.$set(actionItem, 'dateValue', []);
                this.$set(actionItem, 'timeValue', []);
            }
        },
        closeConditionModal() {

        },
        // 维度查询  设置参数
        async saveDimensionValue(params) {
            console.log(params, 'params');
            await this.appleDimensionCheckValid(params)
            let sub_text = this.getDimensionSubText(params)
            const index = this.dimensionCheckList.findIndex(v=>v.name === this.actionDimensionModal.name);
            const item = this.conditionCheckList.find(v=>v.name === this.actionDimensionModal.name);
            if (item) {
                this.$set(item, 'display_name', params.display_name);
            }
            this.dimensionCheckList.splice(index, 1, { ...this.dimensionCheckList[index], ...params,sub_text })
            this.dimensionCheckListFn();
            this.$forceUpdate()
        },
        async appleDimensionCheckValid(params) {
            const fieldsValidNames = Object.keys(APPLE_FIELDS_TYPE)
            const fieldsCheckNames = this.fieldsCheckList.filter(v=>fieldsValidNames.includes(v.name));
            if (
                params.name=== "date"&& 
                params.sum_type !== 'day' &&
                fieldsCheckNames.length
            ) {
                await new Promise((resolve, reject)=> {
                    const tip_field_str = fieldsCheckNames.map(v=>v.display_name).join('、');
                    this.$confirm(`【${tip_field_str}】指标需按【搜索词】与【数据日期（天）】维度展开观测，删除【数据日期（天）】维度将同时删除【${tip_field_str}】指标，确认要删除吗？`, '提示', {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消',
                        type: 'warning',
                        customClass:'wide-confirm-box-550',
                    }).then(async () => {
                        await this.handleCheckChange(
                            false,
                            'fieldsCheckList',
                            fieldsCheckNames
                        );
                        resolve()
                    }).catch(() => { 
                        reject()
                    });
                })
            }
        },
        getConditionSubText(field, val, valueType){
            console.log('getConditionSubText',field, val, valueType);
            if(valueType=='content'){
                let count = (val || []).length;
                let isYYTypeStr = field.name=='yy_type'?(field.selectLabel||''):'';
                let excludeStr = isYYTypeStr+(field.isExclude?'(排除) ':'(包含) ');
                let countText = (val || []).map(item=>item.name).join(',');
                return count==1?excludeStr+countText:excludeStr+count;
            }else{
                console.log('其他类型：待处理');
                return '其他类型';
            }
        },
        getDimensionSubText(field) {
            let values = field || {};
            let sumTypeMap = {
                'day': '天',
                'week': '周',
                'month': '月',
                'quarter': '季度',
                'year': '年',
            };
            let dimensionMap = {
                'bloc_name': '按集团',
                'company_name': '按客户',
                'account_name': this.platId == '9' ? '按广告系列组' : '按账户',
                'app_name': '按产品',
                'main_app_name': '按产品主名称',
                'project_name': '按项目名称',
                'subproject_name': '按推广',
                'plan_name': this.platId == '8' || this.platId == '9' ? '按广告系列' : '按计划',
                'adgroup_name': this.platId == '8' ? '按广告' : '按广告组',
                'ad_name': this.platId == '1' || this.platId == '8' || this.platId == '7' ? '按创意' : '按广告',
                'idea_name': '按创意',
                'task_name': '按任务',
                'sub_task_name': '按子任务',
                'keyword': '按关键词',
                'search_term': '按搜索词',
            };
            // 补充创建日期维度map
            let createDimensionMap = {
                'account_create_time': this.platId == '9' ? '按广告系列组' : '按账户',
                'plan_create_date': this.platId == '8' || this.platId == '9' ? '按广告系列' : '按计划',
                'adgroup_create_date': this.platId == '8' ? '按广告' : '按广告组',
                'ad_create_date': this.platId == '1' || this.platId == '8' || this.platId == '7' ? '按创意' : '按广告',
                'idea_create_date': '按创意',
                'task_create_date': '按任务',
                'sub_task_create_date': '按子任务',
                'keyword_create_date': '按关键词',
            };
            // 补充运营类型维度map
            let yyTypeDimensionMap = {
                'bloc_yy_type': '按集团',
                'company_yy_type': '按客户',
                'account_yy_type': this.platId == '9' ? '按广告系列组' : '按账户',
                'app_yy_type': '按产品',
                'main_app_yy_type': '按产品主名称',
                'project_yy_type': '按项目',
                'subproject_yy_type': '按推广',
                'plan_yy_type': this.platId == '8' || this.platId == '9' ? '按广告系列' : '按计划',
                'adgroup_yy_type': this.platId == '8' ? '按广告' : '按广告组',
                'ad_yy_type': this.platId == '1' || this.platId == '8' || this.platId == '7' ? '按创意' : '按广告',
                'idea_yy_type': '按创意',
                'task_yy_type': '按任务',
                'sub_task_yy_type': '按子任务',
                'keyword_yy_type': '按关键词',
                'search_term_yy_type': '按搜索词',
            };

            let dataArr = [];
            let sumTypeText = sumTypeMap[values.sum_type];
            let startDateDimensionText = dimensionMap[values.start_date_dimension];
            let createDateDimensionText = createDimensionMap[values.create_date_dimension];
            let yyTypeDimensionText = yyTypeDimensionMap[values.yy_type_dimension];
            let orderByText = (this._findFieldByName(this.fieldsTypeList, values.order_by) || {}).display_name;
            let orderTypeText = values.order_type == 'desc' ? '降序' : values.order_type == 'asc' ? '升序' : '';
            let showNumText = values.show_type == '1' ? '全部展示' : values.show_num > 0 ? '展示' + values.show_num + '个' : '';
            if (sumTypeText && field.name == 'date') {
                dataArr.push(sumTypeText);
            }
            if (startDateDimensionText && field.name == 'start_date') {
                dataArr.push(startDateDimensionText);
            }
            if (createDateDimensionText && field.name == 'create_date') {
                dataArr.push(createDateDimensionText);
            }
            if (yyTypeDimensionText && field.name == 'yy_type') {
                dataArr.push(yyTypeDimensionText);
            }
            if (field.name === 'date' && !orderByText) {
                dataArr.push('数据日期' + orderTypeText);
            } else if (field.name === 'time_interval' && !orderByText) {
                dataArr.push('数据时段' + orderTypeText);
            } else if (orderByText) {
                dataArr.push(orderByText + orderTypeText);
            }
            if (field.name != 'date' && showNumText) {
                dataArr.push(showNumText);
            }
            let dataStr = dataArr.join('/');
            return dataStr === '全部展示' ? '' : dataStr;
        },
        _findFieldByName(data, name) {
            for (let item in data) {
                if (data[item].name == name) {
                    return data[item];
                } else {
                    let child = data[item].children;
                    if (child && child.length > 0) {
                        let result = this._findFieldByName(child, name);
                        if (result) {
                            return result;
                        }
                    }
                }
            }
        },
        handleEditDimension(data) {
            if (!this.initDimensionNames[data.name]) {
                this.$message.warning('该字段无权限');
                return
            }
            const params = { ...data, type: this.type, initName: this.initDimensionNames[data.name] };
            this.actionDimensionModal = params;
            this.$nextTick(()=> {
                this.$refs.dimensionModal.showModal();
            })
        },
        handleEditCondition(data){
            if (!this.initDimensionNames[data.name]) {
                this.$message.warning('该字段无权限');
                return
            }
            const params = cloneDeep({ ...data, type: this.type });
            this.actionConditionModal = params;
            this.$nextTick(()=>{
                this.showConditionModal(params);
            })
        },
        handlePlatIdChange(id) {
            this.formInline.plat_id = this.prePlatId;
            const callback = ()=> {
                this.formInline.plat_id = id;
                this.prePlatId = id;
                this.resetTemData()
            }
            this.platChange(callback)
        },
        platChange(callback) {
            if (!this.formInline.plat_id) {
                callback();
                return;
            }
            this.$confirm('修改后，已添加内容将会被清空?', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                callback()
            }).catch(() => { });
        },
        // 更新sheet数据
        updateSheetData() {
            const sheet = this.sheetList.find(v=> {
                return v.name ===this.activeSheet;
            });
            if (sheet) {
                sheet.list.conditionConfig = cloneDeep(this.conditionCheckList);
                sheet.list.dimensionConfig = cloneDeep(this.dimensionCheckList);
                sheet.list.fieldConfig = cloneDeep(this.fieldsCheckList);
                // sheet.list.excel_format_type = this.excel_format_type;
            }
        },
        handleSheetClick(item) {
            if (this.activeSheet === item.name) {
                return;
            }
            if (this.activeSheet) {
                this.updateSheetData()
            }
            // 重新赋值新的sheet
            this.activeSheet = item.name;
            this.conditionCheckList = item.list.conditionConfig;
            this.dimensionCheckList = item.list.dimensionConfig;
            this.fieldsCheckList = item.list.fieldConfig;
            this.conditionCheckListFn();
            this.fieldsCheckListFn()
            this.dimensionCheckListFn()
            // this.excel_format_type = item.list.excel_format_type;
        },
        handleScrollSheet(num) {
            const dom = document.querySelector('.draggable_target');
            const l = dom.scrollLeft;
            // 解决视觉盲区
            const min = Math.floor(dom.clientWidth / 200);
            dom.scrollTo({
                left: l + num * 200 * (min >= 5 ? 5 : min),
                behavior: 'smooth' //  smooth(平滑滚动),instant(瞬间滚动),默认auto
            });
        },
        handleDelSheet(item) {
            if (this.sheetList.length ===1) {
                this.$message.warning('不可删除，至少有一个sheet');
                return
            }
            const index = this.sheetList.indexOf(item);
            this.sheetList = this.sheetList.filter(v => {
                return v !== item
            });
            if (item.name ===  this.selectSheetItem?.name) {
               this.selectSheetItem = null
            }
            if (index == this.sheetList.length) {
                this.handleSheetClick(this.sheetList[index-1])
            }else {
                this.handleSheetClick(this.sheetList[index])
            }
        },
        sheetItemNum() {
            const dom = document.querySelector('.sheet_list');
            const num = Math.floor((dom.clientWidth - 80) / 200);
            if (num < this.sheetList.length) {
                this.showRunButton = true
            } else {
                this.showRunButton = false
            }
        },
        handleCopySheet(sheet) {
            if (this.sheetList.length >= 15) {
                this.$message.warning('最多添加15个sheet');
                return;
            }
            const onSubmit = (data) => {
                if (this.contrastSheetName({}, data)) {
                    this.$message.warning('sheet名称重复，请重新输入')
                }else {
                    this.updateSheetData()
                    const item = {
                        ...cloneDeep(sheet),
                        name: data
                    }
                    this.sheetList.push(item);
                    this.$nextTick(() => {
                        this.handleScrollSheet(this.sheetList.length);
                       this.handleSheetClick(item)
                    })
                    vm.close();
                }
            }
            const { vm } = addSheetDialog({
                props: {
                    value: sheet.name,
                    select: true
                },
                cbs: {
                    onSubmit
                }
            })
        },
        // 判断是不是有重名的sheet名称
        contrastSheetName(sheet, name) {
            const names = this.sheetList.filter(v=> {
                return v !== sheet
            }).map(v=> {
                return v.name;
            });
            return names.includes(name)
        },
        handleEditSheet(sheet) {
            const onSubmit = (data) => {
                if (this.contrastSheetName(sheet, data)) {
                    this.$message.warning('sheet名称重复，请重新输入')
                }else {
                    if (sheet.name === this.activeSheet) {
                        this.activeSheet = data
                    };
                    sheet.name = data;
                    vm.close();
                }
                 
            }
            const { vm } = addSheetDialog({
                props: {
                    value: sheet.name
                },
                cbs: {
                    onSubmit
                }
            })
        },
        handleAddSheet() {
            if (this.sheetList.length >= 15) {
                this.$message.warning('最多添加15个sheet');
                return;
            }
            const onSubmit = (data) => {
                if (this.contrastSheetName({}, data)) {
                    this.$message.warning('sheet名称重复，请重新输入')
                }else {
                    const config = {
                        name: data,
                        list: cloneDeep(this.defaultSheetParams),
                    }
                    this.sheetList.push(config);
                    this.handleSheetClick(config)
                    vm.close();
                    this.$nextTick(()=> {
                        this.handleScrollSheet(15)
                    })
                }
            }
            const { vm } = addSheetDialog({
                props: {
                    value: ''
                },
                cbs: {
                    onSubmit
                }
            })

        },
        handleDelAllSelect() {
            this.dimensionCheckList = [];
            this.fieldsCheckList = [];
            this.conditionCheckList = [];
            this.fieldsCheckListFn()
            this.dimensionCheckListFn()
            this.conditionCheckListFn();
            this.showTableHeader()
        },
        onEnd(list, hide, show) {
            this[list] = [...show, ...hide];
            this[list + 'Fn'] && this[list + 'Fn']()
        },
        fieldsCheckListFn() {
            this.showFieldsList = this.fieldsCheckList.slice(0, this.showMaxOption)
            this.hideFieldsList = this.fieldsCheckList.slice(this.showMaxOption)
        },
        dimensionCheckListFn() {
            this.showDimensionList = this.dimensionCheckList.slice(0, this.showMaxOption)
            this.hideDimensionList = this.dimensionCheckList.slice(this.showMaxOption)
        },
        conditionCheckListFn(){
            this.showConditionList = this.conditionCheckList.slice(0, this.showMaxOption)
            this.hideConditionList = this.conditionCheckList.slice(this.showMaxOption)
        },
        // showDimensionList
        resetOptionWidth() {
            const dom = document.querySelector('.temp_select_list');
            this.showMaxOption = Number.parseInt((dom.clientWidth - 60 - 160) / 160)
            this.fieldsCheckListFn()
            this.dimensionCheckListFn()
            this.conditionCheckListFn();
        },
        handleDelAll(list) {
            this[list] = [];
            this[list + 'Fn'] && this[list + 'Fn']()
        },
        resetDocHeight() {
            this.constentHeight = window.innerHeight - 250;
            this.sheetItemNum()
        },
        handleBack() {
            this.$emit('goBack', true)
        },
        async getPageAllowAction() {
            try {
                this.loading = true
                const { id } = this.$route.meta;
                const result = await HomeAPI.getPageAllowAction({ action_id: id });
                const { dimension, fields } = result.data.page_action[0];
                this.dimensionTypeList = dimension;
                this.fieldsTypeList = fields.filter((v) => {
                    return !this.blackList.includes(v.display_name);
                });
               this.initParamsData()
            } catch (error) {}
            finally {
                this.loading = false
            }

        },
        // 初始化维度 指标的 参数
        initParamsData() {
             let obj = {}
            this.dimensionList.reduce((pre, item)=> {
               if (item.children.length) {
                    pre.push(...item.children)
                }
                return pre;
            }, []).map(async (v)=> {
                if (defaultDimensionNames.includes(v.name) && this.type === 'create') {
                    const defaultNameItem = {
                        ...cloneDeep(v),
                        ...defaultDimensionData
                    }
                    if (defaultNameItem.name ==='date') {
                    defaultNameItem.sum_type = 'day';
                    defaultNameItem.order_by = 'date';
                    defaultNameItem.sub_text = this.getDimensionSubText(defaultNameItem);
                    }
                    this.defaultSheetParams.dimensionConfig.push(defaultNameItem);
                   
                    // 创建时需要加入默认值
                    if (this.type === 'create') {
                       await this.handleCheckChange(true, 'dimensionCheckList', v)
                    }
                };
                this.initDimensionNames[v.name] = v.display_name
                if (defaultConditionNames.includes(v.name) && this.type === 'create') {
                     //20240416 新增 苹果媒体默认选中筛选 数据时区
                    if(this.formInline.plat_id != 9) return
            
                    let apple_default_field = {
                        "title": "数据时区",
                        "id": "3215",
                        "name": "time_zone",
                        "isExclude": false,
                        "contentValue": [
                            {
                                "id": "Asia/Shanghai",
                                "name": "Asia/Shanghai",
                                "checked": true,
                                "isHide": false
                            }
                        ],
                        "select": "account_yy_type"
                    }
                    let apple_default_val = [
                        {
                            "id": "Asia/Shanghai",
                            "name": "Asia/Shanghai",
                            "checked": true,
                            "isHide": false
                        }
                    ]
                    let apple_default_valueType = 'content'
                    
                   this.$nextTick(async ()=> {
                    const conditionItem = await this.saveConditionValue(apple_default_field, apple_default_val, apple_default_valueType, false)
                    this.defaultSheetParams.conditionConfig.push(cloneDeep(conditionItem));
                   })
                }
            });
            this.fieldsList.reduce((pre, item)=> {
                if (item.children.length) {
                    pre.push(...item.children)
                }
                return pre;
            }, []).map(async v=> {
                if (defaultFieldNames.includes(v.name) && this.type === 'create') {
                    this.defaultSheetParams.fieldConfig.push(cloneDeep(v));
                    // 创建时需要加入默认值
                    if (this.type === 'create') {
                        await this.handleCheckChange(true, 'fieldsCheckList', v)
                    }
                }
                // dimensionCheckList
                this.initFieldsNames[v.name] = v.display_name
            });

           
            

            

        },
        async handleCheckChange(value, list, datas) {
            console.log(value, list, datas, 'value, list, datas');
            
            if (this.disabledEdit) {
                return
            };
             if (!Array.isArray(datas)) {
               datas = [ datas ]
                
            } 
            if (datas.length === 0) {
                return;
            };
            if (this.formInline.plat_id === '9') {
                await this.appleCheckValid(value, list , datas)
            }
            datas.map(item=> {
                if (value) {
                    if (list === 'dimensionCheckList') {
                        const data = this.conditionCheckList.find(v=>v.name === item.name);
                        const cloneItem = cloneDeep(item)
                        if (data) {
                            cloneItem.display_name = data.display_name
                        }
                        const defaultData = {
                            ...defaultDimensionData
                        };
                        if (cloneItem.name ==='date') {
                          defaultData.sum_type = 'day';
                          defaultData.order_by = 'date';
                          cloneItem.sub_text = this.getDimensionSubText({...cloneItem, ...defaultData});
                        };
                        if (!this[list].map(v=>v.name).includes(item.name)) {
                            this[list].push(Object.assign({}, cloneItem , defaultData));
                        }
                    }else {
                        if (!this[list].map(v=>v.name).includes(item.name)) {
                            this[list].push({...item});
                        }
                    }

                } else {
                    const index = this[list].findIndex(v => v.name === item.name)
                    if (index > -1) {
                        this[list].splice(index, 1);
                    }
                }
            })
            

            this[list + 'Fn'] && this[list + 'Fn']()
        },
        // 苹果选择效验
        async appleCheckValid(isCheck, key , item) {

            // 维度
            // search_term_text 搜索词  
            // date  数据日期天  
            // 指标
            // impression_share 展示次数份额
            // rank 排名
            // search_popularity 搜索热度
            //   dimensionCheckList: [],
            // fieldsCheckList: [],
            // actionDimensionModal 
            /**
               dimensionTypeList: [],
                fieldsTypeList: [],
             */
           
            const dimensionValidNames = Object.keys(APPLE_DIMENSION_TYPE);
            const fieldsValidNames = Object.keys(APPLE_FIELDS_TYPE);
            
           
           if (key === 'dimensionCheckList' && !isCheck) {
            // 取消 搜索词 数据日期（天）的数据
                const fieldsCheckNames = this.fieldsCheckList.filter(v=>fieldsValidNames.includes(v.name));
                if (!fieldsCheckNames.length) {
                    return;
                }
                const unCheckNames = item.filter(v=>{
                    if (v.name === 'date') {
                        if (v.sum_type) {
                            return v.sum_type === 'day'
                        }else {
                            return true
                        }
                    }else {
                        return dimensionValidNames.includes(v.name)
                    }
                });
                if (!unCheckNames.length) {
                    return;
                };
                await new Promise((resolve, reject)=> {
                    const tip_field_str = fieldsCheckNames.map(v=>v.display_name).join('、');
                    const tip_dimension_str = unCheckNames.map(v=>v.display_name).join('、');
                    this.$confirm(`【${tip_field_str}】指标需按【搜索词】与【数据日期（天）】维度展开观测，删除【${tip_dimension_str}】维度将同时删除【${tip_field_str}】指标，确认要删除吗？`, '提示', {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消',
                        type: 'warning',
                        customClass:'wide-confirm-box-550',
                    }).then(async () => {
                        await this.handleCheckChange(
                            false,
                            'fieldsCheckList',
                            fieldsCheckNames
                        );
                        resolve()
                    }).catch(() => { 
                        reject()
                    });
                })
                return;
            };
            if (key !== 'fieldsCheckList' || !isCheck) {
                return;
            };
            // 添加sov指标
            // 如果没有提示词  就返回
              const filterFieldsList = item.filter(v=>fieldsValidNames.includes(v.name));
            if (!filterFieldsList.length) {
                return;
            };
            const dimensionCheckNames = this.dimensionCheckList.filter(v=>{
                if (v.name === 'date') {
                    return v.sum_type === 'day'
                }else {
                    return dimensionValidNames.includes(v.name)
                }
            }).map(v=>v.name);
            // console.log(this.dimensionCheckList, this.fieldsList, this.dimensionList, this.formInline);
           
            // const hasAlldimension = dimensionValidNames.every(v=> dimensionCheckNames.includes(v));
            // if (hasAlldimension && this.dimensionCheckList.find(v=>v.name==='date' && v.sum_type === 'day')) {
                
            // };
            if (dimensionCheckNames.length === dimensionValidNames.length) {
                return;
            }
            const tip_field_str = item.map(v=>v.display_name).join('、');
            const noCheckNames = dimensionValidNames.filter(name=>!dimensionCheckNames.includes(name));
            const tip_dimension_str = noCheckNames.map(v=>`【${APPLE_DIMENSION_TYPE[v]}】`).join(' ')
            await new Promise((resolve, reject)=> {
                this.$confirm(`【${tip_field_str}】指标需按【搜索词】与【数据日期（天）】维度维度展开观测，需要帮您选择${tip_dimension_str}维度吗？`, '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning',
                    customClass:'wide-confirm-box-550',
                }).then(async () => {
                    const hasDateData = this.dimensionCheckList.find(v=>v.name === 'date'&&v.sum_type !== 'day');
                    
                    if (hasDateData) {
                        await this.saveDimensionValue({ ...hasDateData, sum_type: 'day' })
                        // await this.handleCheckChange(
                        //     false,
                        //     'dimensionCheckList',
                        //     hasDateData
                        // )
                    }
                    await this.handleCheckChange(
                        true,
                        'dimensionCheckList',
                        this.toNameFindData(this.dimensionList, noCheckNames)
                    )
                    console.log(noCheckNames, '确认选择');
                    resolve()
                }).catch(() => { 
                    reject()
                });
            })
        },
        toNameFindData(list, names) {
            const data = list.reduce((pre, item)=> {
                item.children.map(v=>{
                    if (pre[v.name]) {
                        console.log('出现重复的数据', item.display_name, v);
                    }
                    pre[v.name] = v;
                })
                return pre;
            }, {});
            return names.map(name=> data[name]) 
        },
        showTitle(item) {
            try {
                const { title } = JSON.parse(item.config||"{}");
                if (title) {
                    return title
                } else {
                    return false
                }
            } catch (error) {
                return false
            }
        },
        showConditionModal(field) {
            console.log('showConditionModal', field);
            let fieldItem = this.conditionCheckList.find(item=>item.name==field.name);
            if(fieldItem){
                field = fieldItem;
            }


            let fieldConfig = JSON.parse(field.config ||"{}");
            let modalType = fieldConfig.type||'content';
            this.actionConditionModal.title = field.display_name;
            this.actionConditionModal.id = field.id;
            this.actionConditionModal.name = field.name;
            this.actionConditionModal.isExclude = !!field.isExclude;
            if (modalType == 'time'||modalType == 'time_interval') {
                this.actionConditionModal.timeValue = field.timeValue;
                this.$refs.timeModal.showModal();
            } else if (modalType == 'date') {
                this.actionConditionModal.dateValue = field.dateValue;
                this.$refs.dateModal.showModal();
            } else if (modalType == 'date_select') {
                this.actionConditionModal.dateValue = field.dateValue;
                this.actionConditionModal.selectValue = field.selectValue;
                this.$refs.dateSelectModal.showModal();
            } else if (modalType == 'select') {
                this.actionConditionModal.selectValue = field.selectValue;
                this.$refs.selectModal.showModal();
            } else if (modalType == 'content') {
                this.actionConditionModal.contentValue = field.contentValue||[];
                if(field.name=="yy_type"){
                    this.actionConditionModal.selectValue = field.selectValue;
                }
                this.$refs.contentModal.showModal();
            }

            return false;

            const onSubmit = (data) => {
                console.log('onSubmit', data);
                vm.close();
            };
            const { vm } = selectModal({
                options: {
                    title: field.name,
                },
                props: {

                },
                cbs: {
                    onSubmit
                }
            })
        },
        showTableHeader() {
            const sheet = this.sheetList.find(v=> {
                return this.activeSheet === v.name
            });
            const list =  [
                {
                    class: 'dimension',
                    list: cloneDeep(this.dimensionCheckList),
                    init: this.initDimensionNames
                },
                {
                    class: 'field',
                    list: cloneDeep(this.fieldsCheckList),
                    init: this.initFieldsNames
                }
            ]
            sheet.headList = list
            this.headList = list
        }
    }
}
</script>
<style scoped>
.demo-form-inline {
    padding: 20px 20px 0;
    background: #f8f8f9;
}
</style>
<style lang="scss" scoped>
.drag-ghost{
   .info {
     border-color: #1e90ff!important;
    border-style: dashed!important;
    background-color: #ecf5ff!important;
    color: #1e90ff;
    position: relative;
   }
}
.create_page {
    &::v-deep {
        .el-input__inner {
            padding-right: 66px;
        }
        .other-select {
            .el-input__inner {
                padding-right: 35px;
            }
        }
    }
}
.change_color {
    color: #67C23A !important;
}
.grey_color {
    color: #999 !important;
}
.option_list_filter {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 50px;
    z-index: 3;
    background: #fff;
    &::v-deep .el-scrollbar__wrap {
        overflow-x: hidden;
    }
    .no_data {
        color: #999;
        text-align: center;
    }
    .filter_item {
        .title {
            font-size: 12px;
            color: #000;
            font-weight: bold;
            padding: 0 10px 8px;
        }
        p {
            padding-left: 25px !important;
        }
    }
}
.popover-drag {
    max-height: 400px;
    overflow: auto;
    width: 190px;
}
.select_item {
    width: 160px;
    margin: 5px;
    padding: 3px 5px;
    color: #000;
    position: relative;
    border: 1px solid #81d3f8;
    background-color: #d2effc;
    cursor: pointer;
    p {
        padding-right: 24px;
        line-height: 16px;
        .info {
            display: inline;
            color: #999;
        }
    }
    span {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        text-align: center;
        border-left: 1px solid #dcdee2;
        width: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ed4014;
        cursor: pointer;
    }

    &.item_3 {
        border: 1px solid #ffd77a;
        background-color: #fff9e6;
    }

    &.is-exclude{
        border: 1px solid #ffb08f !important;
        background-color: #ffefe6 !important;
    }
}

.pointer {
    cursor: pointer;
}

.temp_create {
    display: flex;
    flex-wrap: nowrap;
    border: 1px solid #ccc;
    width: 100%;
    min-width: 880px;
    min-height: 200px;
    padding: 10px;

    .temp_option {
        display: flex;
        border: 1px solid #ccc;
        width: 300px;
        padding: 10px 5px;
        flex-direction: column;
        position: relative;
        &_bar {
            width: 0;
            padding: 1px;
        }
        .filter-tabs {
            margin-top: 8px;
        }

        .check_name {
            padding-left: 15px;
        }
        .option_btn {
            position: absolute;
            right: -15px;
            top: 50%;
            transform: translateY(-50%);
            height: 50px;
            width: 15px;
            background: #66b1ff;
            border-radius: 0 4px 4px 0;
            color: #fff;
            font-size: 15px;
            line-height: 50px;
            cursor: pointer;
        }
    }

    .option_list {
        flex: 1;
        height: 0;
        overflow-x: hidden;
        &::v-deep {
            .el-scrollbar__wrap {
                overflow-x: hidden;
            }
        }
        .check_all {
            color: #999;
            padding-left: 30px;

            span {
                margin-right: 15px;
                cursor: pointer;
            }
        }
    }

    .temp_select {
        height: 100%;
        flex: 1;
        width: 0;
        margin-left: 25px;
        overflow: auto;
        &_list {
            padding: 5px 8px;
            border: 1px solid #ccc;
        }

        &_item {
            border-bottom: 1px solid #dcdee2;
            display: flex;
            align-items: center;

            .item_name {
                font-weight: bold;
            }

            .item_list {
                flex: 1;
                width: 0;
                display: flex;
                align-items: center;
                margin-left: 10px;
                height: 34px;

            }

            &:nth-child(3) {
                .select_item {
                    border: 1px solid #ffd77a;
                    background-color: #fff9e6;
                }
            }

            .temp_select_del {
                color: #ed4014;
                cursor: pointer;
            }
        }

        &_handle {
            margin-top: 5px;
        }

        &_table {
            overflow: auto;
            color: #000;
            border: 1px solid #ccc;
            padding: 0 10px 10px;
            margin-top: 10px;
            white-space: nowrap;
            min-height: 45px;
            position: relative;
            overflow-y: hidden;

            &::before {
                content: '添加好的维度与指标将在此处作为表头预览';
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                z-index: 0;
                color: #9e9c9c;
            }

            .table_header {
                display: inline-block;
                margin-right: 10px;
                padding: 3px 5px;
                margin-top: 10px;
                position: relative;
                z-index: 2;
            }

            .dimension {
                border: 1px solid #81d3f8;
                background-color: #d2effc;
            }

            .field {
                border: 1px solid #ffd77a;
                background-color: #fff9e6;
            }
        }

        &_tip {
            margin-top: 10px;
            color: #9e9c9c;

            .tip_item {
                margin-top: 8px;

                img {
                    width: 14px;
                    vertical-align: -2px;
                    margin-right: 4px;
                }
            }
        }
    }
}
.select_sheet { 
    margin-top: 10px;
    display: flex;
    align-items: center;
     color: #9e9c9c;
     .tip {
        margin-left: 10px;
     }
     &_list {
        display: flex;
     }
     &_item {
        display: flex;
       position: relative;
        align-items: center;
        cursor: pointer;
        margin-left: 10px;
        p {
            border: 1px dashed #02A7F0;
            padding-left: 4px;
            color: #02A7F0;
            padding-right: 30px;
            min-width: 100px;
        }
        span {
            position: absolute;
            right: 0;
            top: 0;
            width: 20px;
            height: 100%;
            border: 1px dashed red;
            text-align: center;
            line-height: 2;
            color: red;
        }
     }
}
.sheet_box {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background: #edeef1;
    text-align: right;

    .sheet_list {
        text-align: left;
        margin-left: auto;
        width: calc(100% - 54px);
        padding: 1px 8px 0;
        display: flex;

        .sheet_run {
            font-size: 16px;
            padding: 0 5px;
            cursor: pointer;
            display: flex;
            align-items: center;
        }

        .draggable_box {
             overflow: hidden;
             height: 40px;
            &.lock {
                width: 0;
                flex: 1 1 auto;
               
            }
            .draggable_target {
                width: 100%;
                overflow: auto;
                display: flex;
                height: 60px;
                padding: 0 4px;
            }
        }

        .sheet_item {
            border-right: 1px solid #ccc;
            
            width: 200px;
            flex: 0 0 200px;
            .info {
                display: flex;
                align-items: center;
                height: 40px;
                padding: 0 5px 0;
                box-sizing: border-box;
                .sheet_name {
                    flex: 1;
                }

                i {
                    font-size: 16px;
                    margin: 0 3px;
                    cursor: pointer;
                    color: #409EFF;

                    &:first-child {
                        color: #ccc;
                    }

                    &:last-child {
                        color: red;
                    }
                }
            }

            &.active {
                background: #fff;
                box-shadow: 0 0 6px  #999;
                 border-right: none;
                span {
                    color: #409EFF;
                }
            }
        }

        .sheet_add {
            flex-flow: 1;
            border: dotted 2px #409EFF;
            cursor: pointer;
            padding: 3px 8px;
            margin-left: 10px;
            color: #409EFF;
            margin-top: 8px;
        }

        &::v-deep .el-tabs--border-card {
            background: none;
            border: none;
            box-shadow: none;

            >.el-tabs__header {
                background: none;
            }
        }
    }

    .sheet_width {
        width: calc(100% - 220px);
    }
}

@media (max-width: 1280px) {
    .checkList {
        .check_con {
            .check_body {
                .left {

                    // min-width: 550px;
                    .check_left_list {
                        .wk-el-checkbox-group {
                            .wk-el-checkbox {
                                min-width: 33%;
                            }
                        }
                    }
                }

                .right {
                    flex: 0 0 200px;
                }
            }
        }
    }
}

@media (max-width: 1080px) {
    .checkList {
        .check_con {
            .check_body {
                .left {

                    // min-width: 550px;
                    .check_left_list {
                        .wk-el-checkbox-group {
                            .wk-el-checkbox {
                                min-width: 50%;
                            }
                        }
                    }
                }

                .right {
                    flex: 0 0 180px;
                }
            }
        }


    }
}

::v-deep .filter-tabs .el-tabs__item {
    font-size: 12px;
    padding: 0 20px !important;
    height: 32px;
    line-height: 32px;
    font-weight: bold;
}

.filter-tabs::v-deep .el-tabs__header {
    margin: 0;
}

::v-deep .option_list .el-collapse-item__header {
    height: 32px;
    line-height: 32px;
    font-weight: bold;
    font-size: 12px;
}

::v-deep .option_list .el-collapse-item .el-collapse-item__content {
    padding-bottom: 10px;
}

::v-deep .option_list .el-collapse-item:last-child .el-collapse-item__wrap {
    border-bottom: none;
}
</style>
